import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { ReduxDispatch, ReduxRootState } from '../../pages/redux/store';

export const useAppDispatch: () => ReduxDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<ReduxRootState> = useSelector;
